<template>
  <div style="height: 100vh; overflow-y: scroll">
    <appointment-orders :page="page"></appointment-orders>
  </div>
</template>

<script>
import AppointmentOrders from "@/views/appointment/orders/Orders";
export default {
  name: "sm-provider-vender-appointment",
  components: {AppointmentOrders},
  data(){
    return {
      page:{
        id:470
      }
    }
  }
}
</script>

<style scoped>

</style>